"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAGE_PRESETS = exports.PagePresetSchema = exports.PagePresetGeneratedChildRouteSchema = exports.PageSectionPresetSchema = void 0;
exports.getPagePreset = getPagePreset;
exports.getPagePresetForPage = getPagePresetForPage;
const zod_1 = require("zod");
const app_base_config_1 = require("./app-base-config");
const view_component_types_1 = require("./view-component-types");
exports.PageSectionPresetSchema = zod_1.z.object({
    componentType: zod_1.z
        .string()
        .min(1)
        .refine(view_component_types_1.isViewComponentType, {
        error: issue => `unknown view component type "${String(issue.input)}"`,
    }),
    sourceKeys: zod_1.z.array(zod_1.z.string().min(1)),
});
exports.PagePresetGeneratedChildRouteSchema = zod_1.z
    .object({
    title: zod_1.z.string().min(1),
    presetKey: zod_1.z.string().min(1),
    pathPattern: zod_1.z.string().min(1),
})
    .strict();
exports.PagePresetSchema = zod_1.z
    .object({
    presetKey: zod_1.z.string().min(1),
    routeKind: app_base_config_1.RouteKindSchema,
    audience: app_base_config_1.AudienceSchema,
    templateKey: zod_1.z.string().min(1),
    collectionRole: zod_1.z.string().min(1).nullable(),
    publicationModel: app_base_config_1.PublicationModelSchema,
    requiredSourceKeys: zod_1.z.array(zod_1.z.string().min(1)),
    sourceContentModels: zod_1.z.record(zod_1.z.string().min(1), app_base_config_1.AppBaseContentModelSchema),
    allowedComponentTypes: zod_1.z.array(zod_1.z.string().min(1)),
    defaultSections: zod_1.z.array(exports.PageSectionPresetSchema),
    generatedChildRoutes: zod_1.z
        .array(exports.PagePresetGeneratedChildRouteSchema)
        .optional(),
})
    .strict();
exports.PAGE_PRESETS = {
    landing: {
        presetKey: 'landing',
        routeKind: 'static',
        audience: 'public',
        templateKey: 'landing',
        collectionRole: null,
        publicationModel: 'evergreen',
        requiredSourceKeys: ['content'],
        sourceContentModels: { content: 'landing-content' },
        allowedComponentTypes: [
            'app-base-header',
            'app-base-navigation',
            'app-base-footer',
            'hero-banner',
            'markdown-renderer',
            'card-grid',
            'article-list',
            'custom-html-block',
            'section',
            'grid-2',
            'grid-3',
            'kpi-card',
            'bar-chart',
            'line-chart',
            'form-view',
        ],
        defaultSections: [
            { componentType: 'app-base-navigation', sourceKeys: [] },
            { componentType: 'hero-banner', sourceKeys: ['content'] },
            { componentType: 'markdown-renderer', sourceKeys: ['content'] },
            { componentType: 'card-grid', sourceKeys: ['content'] },
            { componentType: 'app-base-footer', sourceKeys: [] },
        ],
    },
    'legal-page': {
        presetKey: 'legal-page',
        routeKind: 'static',
        audience: 'public',
        templateKey: 'legal-page',
        collectionRole: 'content',
        publicationModel: 'evergreen',
        requiredSourceKeys: ['content'],
        sourceContentModels: { content: 'legal-page' },
        allowedComponentTypes: [
            'app-base-header',
            'app-base-navigation',
            'app-base-footer',
            'single-article',
        ],
        defaultSections: [
            { componentType: 'app-base-navigation', sourceKeys: [] },
            { componentType: 'single-article', sourceKeys: ['content'] },
            { componentType: 'app-base-footer', sourceKeys: [] },
        ],
    },
    'blog-index': {
        presetKey: 'blog-index',
        routeKind: 'index',
        audience: 'public',
        templateKey: 'blog-index',
        collectionRole: 'content',
        publicationModel: 'timestamped',
        requiredSourceKeys: ['users', 'content'],
        sourceContentModels: { users: 'app-base-user', content: 'news-article' },
        allowedComponentTypes: [
            'app-base-header',
            'app-base-navigation',
            'app-base-footer',
            'hero-banner',
            'article-list',
            'card-grid',
        ],
        defaultSections: [
            { componentType: 'app-base-navigation', sourceKeys: [] },
            { componentType: 'article-list', sourceKeys: ['content'] },
        ],
        generatedChildRoutes: [
            {
                title: 'Beitrag',
                presetKey: 'blog-post',
                pathPattern: ':slug',
            },
        ],
    },
    'blog-post': {
        presetKey: 'blog-post',
        routeKind: 'detail',
        audience: 'public',
        templateKey: 'blog-post',
        collectionRole: 'content',
        publicationModel: 'timestamped',
        requiredSourceKeys: ['users', 'content'],
        sourceContentModels: { users: 'app-base-user', content: 'news-article' },
        allowedComponentTypes: [
            'app-base-header',
            'hero-banner',
            'app-base-navigation',
            'app-base-footer',
            'single-article',
            'related-entries',
            'tag-display',
        ],
        defaultSections: [
            { componentType: 'app-base-navigation', sourceKeys: [] },
            { componentType: 'single-article', sourceKeys: ['content'] },
        ],
    },
    'intranet-dashboard': {
        presetKey: 'intranet-dashboard',
        routeKind: 'dashboard',
        audience: 'internal',
        templateKey: 'intranet-dashboard',
        collectionRole: 'content',
        publicationModel: 'evergreen',
        requiredSourceKeys: ['users', 'content'],
        sourceContentModels: {
            users: 'app-base-user',
            content: 'intranet-dashboard-item',
        },
        allowedComponentTypes: [
            'app-base-header',
            'kpi-card',
            'bar-chart',
            'line-chart',
            'app-base-navigation',
            'app-base-footer',
            'card-grid',
            'table-view',
            'filter-bar',
            'search-bar',
        ],
        defaultSections: [
            { componentType: 'app-base-navigation', sourceKeys: [] },
            { componentType: 'filter-bar', sourceKeys: ['content'] },
            { componentType: 'kpi-card', sourceKeys: ['content'] },
            { componentType: 'line-chart', sourceKeys: ['content'] },
            { componentType: 'bar-chart', sourceKeys: ['content'] },
            { componentType: 'table-view', sourceKeys: ['content'] },
        ],
    },
    'workflow-form': {
        presetKey: 'workflow-form',
        routeKind: 'form',
        audience: 'public',
        templateKey: 'workflow-form',
        collectionRole: 'forms',
        publicationModel: 'submission',
        requiredSourceKeys: ['forms', 'submissions'],
        sourceContentModels: {
            forms: 'workflow-form',
            submissions: 'workflow-submission',
        },
        allowedComponentTypes: [
            'app-base-header',
            'app-base-navigation',
            'app-base-footer',
            'hero-banner',
            'form-view',
        ],
        defaultSections: [
            { componentType: 'app-base-navigation', sourceKeys: [] },
            { componentType: 'form-view', sourceKeys: ['forms'] },
        ],
    },
    custom: {
        presetKey: 'custom',
        routeKind: 'custom',
        audience: 'public',
        templateKey: 'custom',
        collectionRole: null,
        publicationModel: 'evergreen',
        requiredSourceKeys: [],
        sourceContentModels: {},
        allowedComponentTypes: [
            'app-base-header',
            'hero-banner',
            'app-base-navigation',
            'app-base-footer',
            'card-grid',
            'article-list',
            'single-article',
            'table-view',
            'form-view',
        ],
        defaultSections: [],
    },
};
function getPagePreset(presetKey) {
    const preset = exports.PAGE_PRESETS[presetKey];
    return preset ? exports.PagePresetSchema.parse(preset) : null;
}
function getPagePresetForPage(page) {
    return getPagePreset(page.templateKey);
}
